import { render } from "./Slide3.vue?vue&type=template&id=3225100e&scoped=true"
import script from "./Slide3.vue?vue&type=script&lang=js"
export * from "./Slide3.vue?vue&type=script&lang=js"

import "./Slide3.vue?vue&type=style&index=0&id=3225100e&lang=scss&scoped=true"
import "./Slide3.vue?vue&type=style&index=1&id=3225100e&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3225100e"]])

export default __exports__